import { Grid, Typography, Button, TextField, Link} from '@mui/material'
import colors from '../../../../../colors'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeConfirmationDialogState, resetVodafoneTopUpSlice, selectVodafoneTopupState,setIsTransactionSuccessfullyStarted, setIsTransactionSuccessfullyCompleted, setSubscriberBalance, setTransactionId } from '../../../../../../features/vodafone/vodafoneTopupSlice'
import { selectBasicAccountState, setShouldBasicAccountPaymentRun, setTransactionIdToCancel } from '../../../../../../features/basicAccount/basicAccountSlice'
import { setGeneralMessage } from '../../../../../../features/global/globalDataSlice'
import { sendGeneralRequest } from '../../../../../../features/generalRequest'
import ConfirmationDialog from '../../../../../general/ConfirmationDialog'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Iframe from 'react-iframe'
import {runBasicAccountPayment} from '../../../../../general/BasicAccountMethods'
import { selectMyContractsState, setShouldFillFields } from '../../../../../../features/myContracts/myContractsSlice'
import { useNavigate } from 'react-router-dom'
import { texts } from '../../../../../general/texts';
import ButtonGroup from '../../../../../general/ButtonGroup'
import Autocomplete from '@mui/material/Autocomplete';
import { selectUtilityState, setIsScaCompleted, setScaRequired } from '../../../../../../features/utilities/utilitySlice'


export const VodafoneTopup = (props) => {
    const searchMethods = [
        { display: texts["button-top-up-card"], value:'1'},
        { display: texts["title-offers"], value:'2'}
    ]
    const [state, setState] = React.useState({
        token: props.globalDataSliceState.token,
        selectedSearchMethod: searchMethods[0].value,
        phone: '',
        value: '',
        serviceName: props.utilityName,
        isFirstRun: true
    })

    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const basicAccountSliceState = useSelector(selectBasicAccountState)
    const vodafoneTopupSliceState = useSelector(selectVodafoneTopupState) 
    const myContractsSliceState = useSelector(selectMyContractsState)
    const utilitySliceState = useSelector(selectUtilityState)
    const navigate = useNavigate()

    const handleTextFieldChange = (prop) => (e) => 
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const startTransaction = () => 
    { 
        dispatch(sendGeneralRequest({request: {...state, value: Number(state.value), phone: state.phone.replace(/^0+/, '')}, baseUrlKey:'services', endpoint:'ASBS/StartVodafoneTopUPMNO'}))
        dispatch(changeConfirmationDialogState())
    }
    const handleSearchButtonClick = () => 
    {
        if(state.selectedSearchMethod === '1')
        {
            if(state.phone === '' || !new RegExp('^[0-9]+$').test(state.value))
            {   
                dispatch(setGeneralMessage({type: 'error', message: texts["message-complete-fields"]}))
            }
            else
            {
                dispatch(changeConfirmationDialogState())
            } 
        }
        if(state.selectedSearchMethod === '2' && state.phone != undefined)
        {
            dispatch(setTransactionId(state.value))
            dispatch(setSubscriberBalance(5000))
            dispatch(setIsTransactionSuccessfullyCompleted(true))
        }
    }
 

    const handleBackButton = () => 
    {
        dispatch(setShouldBasicAccountPaymentRun(false))
        dispatch(resetVodafoneTopUpSlice())
    }

    const getSearchMethodValue = (value) => 
    {
        setState({...state, selectedSearchMethod: value})
    }

    React.useEffect(()=>{
        if(props.vodafoneTopupSliceState.isTransactionSuccessfullyStarted)
        {
            if(userInfo.accountType === 3)
            {
                dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, paymentMethod:'2', applicationID:1, value: Number(state.value), transID: props.vodafoneTopupSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
                dispatch(setTransactionIdToCancel(props.vodafoneTopupSliceState.transactionId)) 
            }
            else
            {
                if (!utilitySliceState.isScaRequired){
                dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.vodafoneTopupSliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true }, baseUrlKey:'services', endpoint:'ASBS/ConfirmVodafoneTopUPMNO'})) 
                }
            }
            // userInfo.accountType === 3 
            //     ? dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, paymentMethod:'2', applicationID:1, value: Number(state.value), transID: props.vodafoneTopupSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
            //     : dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.vodafoneTopupSliceState.transactionId}, baseUrlKey:'services', endpoint:'ASBS/ConfirmVodafoneTopUPMNO'}))
                
            dispatch(setIsTransactionSuccessfullyStarted(false))
        }
        if(props.vodafoneTopupSliceState.isTransactionSuccessfullyCompleted)
        {
            dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, phone: state.phone}, baseUrlKey:'services', endpoint:'ASBS/GetVodafoneListOfOffers'})) 
            dispatch(setIsTransactionSuccessfullyCompleted(false))
        } 
        if (utilitySliceState.isScaRequired){
            if (utilitySliceState.isScaCompleted){
                dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.vodafoneTopupSliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true }, baseUrlKey:'services', endpoint:'ASBS/ConfirmVodafoneTopUPMNO'}))
                dispatch(setScaRequired(false))
                dispatch(setIsScaCompleted(false))
            }
        }
    }, [props.vodafoneTopupSliceState.isTransactionSuccessfullyStarted, props.vodafoneTopupSliceState.isTransactionSuccessfullyCompleted, utilitySliceState.isScaRequired, utilitySliceState.isScaCompleted])
    

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                phone: props.selectedContractInfo.contract
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])

    React.useEffect(()=>{
        if (state.selectedSearchMethod === '2' && state.isFirstRun)
        {
            state.isFirstRun = false
            dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, service: props.utilityName}, baseUrlKey:'services', endpoint:'DailyTransaction'}))
        }
    }, [state.selectedSearchMethod])

    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        width:'150px',
        height:'40px',
        fontFamily:'GerberaBold',
        textTransform:'none',
        fontSize:'1rem',
        border: '2px solid'+colors.orange,
        borderRadius:'10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}                 
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        width:'150px',
        height:'40px',
        borderRadius:'10px',
        textTransform:'none',
        fontFamily:'GerberaLight',
        fontSize:'1rem',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}      
    }

    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor: colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold',
        },
        buttonGrid:{
            marginTop:150,
            paddingBottom:5
        },
        image:{
            width:'70%'
        },
        textField:{
            width:'100%'
        }
    })
    
    const classes = useStyles()


  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3} >
        {
            basicAccountSliceState.shouldBasicAccountPaymentRun 
            ? 
                runBasicAccountPayment(
                        dispatch,
                        basicAccountSliceState.basicAccountPaymentUrl,
                        {request: {token: props.globalDataSliceState.token, transID: props.vodafoneTopupSliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint:'ASBS/ConfirmVodafoneTopUPMNO'},
                        {request: {token: props.globalDataSliceState.token, orderId: props.vodafoneTopupSliceState.transactionId}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'},
                        handleBackButton
                    ) 
            :
            
                <>
                    <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
                    <Grid container item md={12} xs={12} >
                    <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
                        <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
                    </Grid>
            <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3}>
                <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue} />
            </Grid>
        {state.selectedSearchMethod === '1' &&
            <Grid container item rowSpacing={3}  >
                <Grid item md={12} xs={12}  >
                    <Typography className={classes.fieldTitle}>{texts["title-field-number"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('phone')} value={state.phone} color='warning' size='small' label={texts["placeholder-utility-number"]} className={classes.textField}/>
                </Grid>
                    <Grid item md={12} xs={12}>
                        <Typography className={classes.fieldTitle}>{texts["title-field-amount"]}</Typography>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <TextField onChange={handleTextFieldChange('value')} value={state.value} color='warning' size='small' label={texts["placeholder-utility-amount"]} className={classes.textField} />
                    </Grid>
            </Grid>
            }
            {state.selectedSearchMethod === '2' &&
                <Grid container item rowSpacing={3} >
                    <Grid item md={12} xs={12} >
                        <Typography className={classes.fieldTitle}>{texts["title-field-number"]}</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} >
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={props.vodafoneTopupSliceState.lastTransactionsData || []}
                            getOptionLabel={(option) => option.key}
                            onChange={(event, option) => {
                                handleTextFieldChange('phone')(event); 
                                setState({ ...state, phone: option.key, value: option.value }); 
                            }}
                            
                            sx={{ width: '100%' }}
                            renderInput={(params) => <TextField {...params} label={texts["placeholder-choose-number"]} size="small" color="warning" value={state.phone}
                            />}
                        /> 
                    </Grid> 
                </Grid>
            }
                <Grid item md={12} xs={12} className={classes.buttonGrid}>
                    <Button disabled={ vodafoneTopupSliceState.isLoading || (state.selectedSearchMethod === '2' && state.phone === '')} onClick={handleSearchButtonClick} className={classes.button}>
                        {state.selectedSearchMethod === '2' ? texts["button-load-offers"] : texts["title-topup"]}
                    </Button>
                </Grid>
                {props.vodafoneTopupSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={props.vodafoneTopupSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={startTransaction}/>}
            </>   
            }
        </Grid>
  )
}
export default VodafoneTopup

